function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#241F21;}\r\n\t.st1{fill:#231F20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M19,1.5v5c0,0.202-0.122,0.385-0.309,0.462C18.63,6.988,18.564,7,18.5,7c-0.13,0-0.258-0.051-0.354-0.146 L16,4.707l-4.146,4.147C11.756,8.951,11.628,9,11.5,9s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707L15.293,4 l-2.146-2.146c-0.143-0.143-0.186-0.358-0.108-0.545S13.298,1,13.5,1h5C18.776,1,19,1.224,19,1.5z M18.691,13.038 c-0.186-0.079-0.401-0.035-0.545,0.108L16,15.293l-4.146-4.147c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707L15.293,16 l-2.146,2.146c-0.143,0.143-0.186,0.358-0.108,0.545S13.298,19,13.5,19h5c0.276,0,0.5-0.224,0.5-0.5v-5 C19,13.298,18.878,13.115,18.691,13.038z M4.707,4l2.146-2.146C6.996,1.71,7.039,1.496,6.962,1.309S6.702,1,6.5,1h-5 C1.224,1,1,1.224,1,1.5v5c0,0.202,0.122,0.385,0.309,0.462C1.37,6.988,1.436,7,1.5,7c0.13,0,0.258-0.051,0.354-0.146L4,4.707 l4.146,4.147C8.244,8.951,8.372,9,8.5,9s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L4.707,4z M8.146,11.146L4,15.293 l-2.147-2.147c-0.143-0.143-0.358-0.186-0.545-0.108C1.122,13.115,1,13.298,1,13.5v5C1,18.776,1.224,19,1.5,19h5 c0.202,0,0.385-0.122,0.462-0.309s0.034-0.402-0.108-0.545L4.707,16l4.146-4.147c0.195-0.195,0.195-0.512,0-0.707 S8.342,10.951,8.146,11.146z"
});

function SvgMaximiseScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximiseScreen);
export default __webpack_public_path__ + "static/media/maximise_screen.3f253c9d.svg";
export { ForwardRef as ReactComponent };